<template>
    <div class="float-left mr-1">
        <b-button variant="warning" @click.stop="confirmarReprovacao()">
            <span> <i class="fa fa-ban mr-2"></i> Reprovar </span>
        </b-button>
    </div>
</template>

<script>
import AtualizacoesCadastraisServicos from './AtualizacoesCadastraisServicos'

export default {
    props: {
        atualizacaoCadastralId: {
            type: String,
            default: ''
        },

        cpfCnpj: {
            type: String,
            default: ''
        },

        razaoSocial: {
            type: String,
            default: ''
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarReprovacao() {
            this.$swal({
                title: 'Atualização Cadastral',
                html: `Confirma a REPROVAÇÃO da atualização cadastral do fornecedor
                    ${this.cpfCnpj} - ${this.razaoSocial}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                input: 'textarea',
                inputPlaceholder: 'Informe a justificativa da reprovação',
                inputValidator: value => {
                    if (!value) {
                        return 'A justificativa da reprovação é obrigatória'
                    }
                }
            }).then(result => {
                if (result.value) {
                    this.reprovar(result.value)
                }
            })
        },

        reprovar(justificativa) {
            this.$store.dispatch('addRequest')
            let atualizacaoCadastralDto = {
                atualizacaoCadastralId: this.atualizacaoCadastralId,
                justificativa: justificativa
            }
            AtualizacoesCadastraisServicos.reprovar(
                atualizacaoCadastralDto
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso(response.data)
                    } else {
                        this.$emit('atualizarErro', response.errors)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso(data) {
            this.$toast.success(
                'Atualização cadastral reprovada com sucesso',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterAtualizacaoCadastralAtualizada')
        }
    }
}
</script>
